import { render, staticRenderFns } from "./EmptyAlert.vue?vue&type=template&id=9d599f04&scoped=true&"
import script from "./EmptyAlert.vue?vue&type=script&lang=js&"
export * from "./EmptyAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d599f04",
  null
  
)

export default component.exports